define('models/pages/multi-account/table',['require','models/base/table'],function(require) {
    'use strict';

    var TableModel = require('models/base/table');

    var Table = TableModel.extend({
        urlPath: '/api/multi-account/detail',
        urlParams: function() {
            return this.get('params').urlParams();
        },
        parse: function(data) {
            console.log('accounts table', data);
            var item, i, li;
            data = data || [];
            for (i=0, li=data.length; i<li; i++){
                item = data[i];
            }
            return {
                items: data
            };
        }
    });

    return Table;
});


